import React from "react"
import Identities from "@/components/Identities"
const IdentitiesView = () => {
  return (
    <>
      <Identities />
    </>
  )
}

export default IdentitiesView
